import React from 'react';
import { Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#000000] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-[7.6923%] py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-2 space-y-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-[#00FFD1] flex items-center justify-center rounded-sm">
                <span className="text-black font-bold text-xl">RL</span>
              </div>
              {/* BRAND TEXT IN GREEN */}
              <span 
                className="font-semibold text-xl" 
                style={{ color: '#00FFD1' }}
              >
                Ruma Logistics
              </span>
            </div>
            <p className="text-white/50 leading-relaxed max-w-md">
              The complete mobile dashboard for distribution and marketing control. 
              Built for independent distributors to scout leads, manage routes, 
              and track sales—all in one pocket app.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Product</h4>
            <ul className="space-y-3">
              {['Features', 'Workflow', 'Demo', 'Testimonials', 'FAQ'].map((link) => (
                <li key={link}>
                  <a 
                    href={`#${link.toLowerCase()}`}
                    className="text-white/50 hover:text-[#00FFD1] transition-colors"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Support */}
          <div>
            <h4 className="text-white font-semibold mb-6">Inquiries</h4>
            <p className="text-white/50 text-sm leading-relaxed mb-4">
              Interested in a custom setup for your distribution team?
            </p>
            <a 
              href="#concierge" 
              className="inline-flex items-center gap-2 text-[#00FFD1] hover:underline text-sm font-medium"
            >
              <Mail className="w-4 h-4" />
              Request a Demo
            </a>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="space-y-1 text-center md:text-left">
            <p className="text-white/40 text-sm">
              © {currentYear} Ruma Logistics. All rights reserved.
            </p>
            <p className="text-white/20 text-[10px] tracking-wider uppercase">
              Ruma Logistics is a trade name of Ruma Vibes LLC
            </p>
          </div>
          <div className="flex gap-6">
            {/* UPDATED LINK BELOW */}
            <a href="/privacy.html" className="text-white/40 text-sm hover:text-white/70 transition-colors">Privacy Policy</a>
            <a href="#" className="text-white/40 text-sm hover:text-white/70 transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;